import { Component } from '@angular/core';
import { Wrapper } from '../../components/wrapper.component';
import { HomeBudgetSubpage, HomeBudgetSubpages } from '../../store/reselectors/budget.data';
import { budgetSubpageReselector } from '../../store/reselectors/routing.reselector';
import { HomeWrapperComponent } from 'src/app/components/nav-bar/home-wrapper.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { CommonModule } from '@angular/common';
import { JoiAccount } from 'globals/store/accounts.data';
import { accountActions } from 'src/app/store/accounts.era';
import { RouterOutlet } from '@angular/router';
import { AccountMenuComponent } from 'src/app/components/home/account-menu.component';
import { traceNames } from 'src/app/services/performance.tracking.data';

@Component({
    selector: 'home-budget',
    templateUrl: './home-budget.html',
    styleUrls: ['./home-budget.scss', '../../page.scss'],
    standalone: true,
    imports: [HomeWrapperComponent, AccountMenuComponent, RouterOutlet, LoaderPaneFragmentComponent, JoiNavWrapper, CommonModule]
})
export class HomeBudgetComponent extends Wrapper<HomeBudgetComponent> {

  subPage: HomeBudgetSubpage
  menuItems: HomeBudgetSubpage[] = HomeBudgetSubpages
  hiddenMobileItems: Set<HomeBudgetSubpage> = new Set(['quotes', 'table', 'line-items'])
  menuMap: { [K in HomeBudgetSubpage]: string } = { summary: 'SUMMARY', quotes: 'QUOTES', table: 'BUDGET TABLE', 'line-items': 'LINE ITEMS', share: 'SHARE' }
  traceNames = traceNames
  constructor() {
    super()
    this.selectProp(budgetSubpageReselector, null, 'subPage')
  }

  changeSubpage(subPage: HomeBudgetSubpage) {
    console.log({ subPage })
    this.router.navigate(['budget', subPage ])
  }

  openAccount(account: JoiAccount) {
    this.store.dispatch(accountActions.selectBudgetAccount(account.id))
  }

}

